import { Box, Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

export function UsersFilter({ onFiltered, initialUsers, disablePadding }) {
  const [users, setUsers] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    async function fetchData() {
      await loadUsers();
    }
    fetchData();
  }, []);

  useEffect(() => {
    setSelecteds([]);
    if (
      Array.isArray(initialUsers) &&
      Array.isArray(users) &&
      users.length > 0
    ) {
      onChange(initialUsers);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialUsers, users]);

  const loadUsers = async () => {
    try {
      const { data } = await api.get(`/users/list`);
      const userList = data.map((u) => ({ id: u.id, name: u.name }));
      setUsers(userList);
    } catch (err) {
      toastError(err);
    }
  };

  const ALL_ID = "__ALL__";
  const allSelected = users.length > 0 && selecteds.length === users.length;

  const onChange = async (value) => {
    // Opção sintética "Selecionar todos": alterna entre todos e nenhum.
    // Nunca entra em `selecteds`, então não vira chip.
    if (Array.isArray(value) && value.some((v) => v?.id === ALL_ID)) {
      const next = allSelected ? [] : users;
      setSelecteds(next);
      onFiltered(next);
      return;
    }
    setSelecteds(value);
    onFiltered(value);
  };

  return (
    <Box style={{ padding: disablePadding ? "0px" : "0px 10px 10px" }}>
      <Autocomplete
        multiple
        size="small"
        options={
          users.length > 0
            ? [
                {
                  id: ALL_ID,
                  name: allSelected
                    ? i18n.t("tickets.search.clearAllUsers")
                    : i18n.t("tickets.search.selectAllUsers"),
                },
                ...users,
              ]
            : users
        }
        value={selecteds}
        onChange={(e, v, r) => onChange(v)}
        getOptionLabel={(option) => option.name}
        getOptionSelected={(option, value) => {
          return (
            option?.id === value?.id ||
            option?.name.toLowerCase() === value?.name.toLowerCase()
          );
        }}
        renderTags={(value, getUserProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              style={{
                backgroundColor: "#bfbfbf",
                textShadow: "1px 1px 1px #000",
                color: "white",
              }}
              label={option.name}
              {...getUserProps({ index })}
              size="small"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={i18n.t("tickets.search.filterUsers")}
          />
        )}
      />
    </Box>
  );
}
